<ng-dialog-header title="Car Transaction Event History"></ng-dialog-header>
<mat-dialog-content class="d-flex flex-column flex-grow-1">
  <div class="d-flex">
    <div class="d-flex">
      <h3>
        <span class="font-weight-bold">Transaction Event History For car: </span>
        <span class="font-weight-normal"> {{ carId }}</span>
      </h3>
    </div>
    <div class="d-flex ml-2">
      <h3>
        <span class="font-weight-bold">Request Number: </span>
        <span class="font-weight-normal"> {{ requestNumber }}</span>
      </h3>
    </div>
  </div>
  <ns-grid [name]="configs.gridName" [gridTitle]="configs.gridTitle" [columns]="configs.columns" [data]="events"
           [config]="configs.headerOptions" [gridOptions]="configs.options" [loading]="loading"
           [rowSelection]="configs.rowSelection">
  </ns-grid>
</mat-dialog-content>
<ng-dialog-footer>
  <div class="d-flex justify-content-end w-100" dialog-actions>
    <button mat-flat-button mat-dialog-close color="accent" cdkFocusInitial aria-label="OK Dialog Button">
      OK
    </button>
  </div>
</ng-dialog-footer>
